import { getTrackingCollectionAttributes } from 'homepage/utils/getTrackingCollectionAttributes';

/**
 * [getSearchLandingFeedSectionTrackingInfo]
 * All of the tracking events for homepage content require these 5 attributes.
 * They're passed down into each section, so we can fire events from deeper down in the tree. (ported from old goat.com)
 *
 * @param   {Object} section      The section itself.
 * @param   {Number} sectionIndex Position of section in list, starting at 0
 * @param   {Number} draftId      Draft ID for current feed
 * @param   {String} draftUuid    Draft UUID for current feed (draftId will be deprecated later)
 * @param   {Number} sectionSubsectionPosition Position of section in list, starting at 0
 * @returns {Object}
 */
export const getSearchLandingFeedSectionTrackingInfo = (
  section,
  sectionIndex: number,
  draftId?: number,
  draftUuid?: string,
  context = 'search_landing',
) => {
  const collectionAttr = getTrackingCollectionAttributes(section);

  return {
    event_context: context,
    draft_id: draftUuid || String(draftId),
    section_id: section?.uuid || String(section?.id),
    section_position: sectionIndex,
    section_type: section?.type,
    section_name: section?.title || section?.subject,
    segment_id: section?.segmentId,
    ...collectionAttr,
  };
};
